export default {
  state: {
    list: [],
    extends: []
  },
  getters: {
    getProduct: state => code => {
      return state.list.find(item => item.code === code);
    },
    getProductExtend: state => code => {
      return state.extends.find(item => item.code === code);
    },
    /**
     * type:Number 分类，0:全部，1团险，2个险
     * includeProduct:Boolean 分类下是否包含产品信息
     */
    getCategoryList: state => (type, includeProduct) => {
      let categories = [];
      // let products =
      //   type === 0
      //     ? state.list
      //     : state.list.filter(item => item.isGroup === (type === 1));
      const products = state.list.filter(item => {
        if (type !== 0 && item.isGroup !== (type === 1) ){
          return false;
        }
        if (!item.hasOwnProperty("endTime")){
          return true;
        }
        let endTimeStamp = new Date(item.endTime).getTime();
        let currentTimeStamp = new Date().getTime();
        if (currentTimeStamp > endTimeStamp){
          return false;
        }
        return true;
      })

      products.forEach(element => {
        element.categories.forEach(category => {
          if (categories.findIndex(o => o.name === category) === -1) {
            categories.push({
              name: category
            });
          }
        });
      });
      if (includeProduct) {
        categories.forEach(category => {
          const categoryProducts = products.filter(item =>
            item.categories.includes(category.name)
          );
          categoryProducts.sort((a, b) => a.order - b.order);
          category.products = categoryProducts;
        });
      }
      return categories;
    }
  },
  mutations: {
    setList(state, val) {
      state.list = val;
    },
    setExtends(state, val) {
      state.extends = val;
    }
  },
  actions: {
    async getProducts({ commit, state }) {
      return new Promise(resolve => {
        if (state.list && state.list.length > 0) {
          resolve(state.list);
        } else {
          this.$axios.get("/json/products.json").then(list => {
            commit("setList", list);
            resolve(list);
          });
        }
      });
    },
    async getProductExtends({ commit, state }) {
      return new Promise(resolve => {
        if (state.extends && state.extends.length > 0) {
          resolve(state.extends);
        } else {
          this.$axios.get("/json/productExtends.json?v1").then(list => {
            commit("setExtends", list);
            resolve(list);
          });
        }
      });
    }
  }
};
